import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import { Form, Button } from "react-bootstrap"
import { Redirect } from 'react-router-dom';
import TextField from '../components/LoginSignupTextfield';
import './LoginSignup.css'
import Login from './Login'


class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmationCodeView: false,
            newPasswordView: false,
            password: "",
            confirmationCode: "",
            username: "",
            passwordError: "",
            switchToExplore: false,
            switchToLanding: false,
            switchToLogIn: false, 
            identifierError: "",
            codeError: ""
        }
    }

    handleUsernameChange = (event) => {
        this.setState({
            username: event.target.value
        })
    }

    sendCode = async () => {
        if (this.state.username !== "") {
            await Auth.forgotPassword(this.state.username)
            this.setState({
                confirmationCodeView: true

            })
        }
        else {
            this.setState({
                identifierError: "This field cannot be empty"
            })
        }

    }

    goToReset = () => {
        if (this.state.confirmationCode.length === 6) {
            this.setState({
                newPasswordView: true
            })
        }
        else{
            this.setState({
                codeError:"Please enter a 6 digit code"
            })
        }


    }

    storeVerificationCode = (event) => {
        this.setState({
            confirmationCode: event.target.value
        })
    }

    storeNewPassword = (event) => {
        this.setState({
            password: event.target.value
        })
    }

    setPasswordError = (error) => {
        this.setState({
            passwordError: error

        })
    }

    resetPassword = async () => {
        if (this.passwordValidation()) {
            try {
                await Auth.forgotPasswordSubmit(this.state.username, this.state.confirmationCode, this.state.password)
                await Auth.signIn(this.state.username, this.state.password)
                this.setState({
                    switchToExplore: true

                })
            }
            catch (error) {
                alert("Something isn't right. Report the issue or try resetting your password again")
                this.setState({
                    switchToLanding: true
                })
                console.log(error)
            }
        }
    }

    isAlphaNumeric = (character) => {
        return (/^[a-z0-9]+$/i.test(character))
    }

    isNumeric = character => {
        return (/^(0|[1-9][0-9]*)$/i.test(character))
    }

    isPasswordSpecialCharacter = (character) => {
        let special_chars = "~!@#$%^&*_-+=`|(){}[]:;'<>,.?/\\"
        return (special_chars.includes(character))
    }

    passwordValidation = () => {

        let special_char_count = 0
        let error = ""

        if (this.state.password === this.state.username.toLowerCase()) {
            error = "Password cannot be indentical to username"
            this.setPasswordError(error)
            return false
        }

        else if (this.state.password.length >= 8 && this.state.password.length <= 40) {
            console.log("here")
            for (let i = 0; i < this.state.password.length; i++) {
                if (this.isPasswordSpecialCharacter(this.state.password[i]) || (this.isNumeric(this.state.password[i]))) {
                    special_char_count++
                }
                else if (!this.isAlphaNumeric(this.state.password[i]) && !this.isPasswordSpecialCharacter(this.state.password[i])) {
                    error = "There is a not allowed character in the password"
                    this.setPasswordError(error)
                    return false
                }
            }

            if (special_char_count === 0) {
                error = "Password must include a letter or a special character"
                this.setPasswordError(error)

                return false
            }

            error = ""
            this.setPasswordError(error)

            return true
        }
        else {
            error = "Password has to be 8-40 characters long"
            this.setPasswordError(error)


            return false
        }

    }

    resendConfirmationCode = async () => {
        this.sendCode()
    }

    switchToLogIn = () => {
        this.setState({
            switchToLogIn:true
        })
    }


    displayStep = () => {

        if (this.state.switchToExplore) {
            return (<Redirect to="/app/explore"></Redirect>)

        }

        else if (this.state.switchToLogIn){
            return(<Login/>)
        }

        else if (this.state.switchToLanding) {
            return (<Redirect to="/"></Redirect>)
        }

        else if (this.state.newPasswordView) {
            return (<>
                <h1>RESET PASSWORD</h1>
                <p>Create a new password with both letters and numbers!</p>
                <br></br>
                <Form onChange={this.storeNewPassword} style={{ display: "flex", flexDirection: 'column', margin: "20px" }}>
                    <TextField margin="normal" id="code" label="New password" type="password" />
                    <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.passwordError}</p>
                </Form>

                <Button style={{ width: "100%", height: "40px" }} onClick={this.resetPassword} variant="primary" type="submit">
                    Reset password
                </Button>
            </>)
        }

        else if (this.state.confirmationCodeView) {
            return (<>
                <h1>FORGOT PASSWORD</h1>
                <p>Check your email or phone for a verification code from us! </p>
                <Form onChange={this.storeVerificationCode} style={{ display: "flex", flexDirection: 'column', margin: "20px" }}>
                    <TextField margin="normal" id="code" label="Verification code" />
                    <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.codeError}</p>

                    <p
                        onClick={this.resendConfirmationCode}
                        style={{ textDecoration: "underline", color: "rgb(103, 212, 239)", cursor: "pointer" }}>
                        I did not receive my code. Resend it.</p>

                </Form>

                <Button style={{ width: "100%", height: "40px" }} onClick={this.goToReset} variant="primary" type="submit">
                    Continue
                </Button>
            </>
            )
        }
        else {
            return (
                <>
                    <h1>FORGOT PASSWORD</h1>
                    <p>Don't worry, it happens to all of us!</p>
                    <p> What username, email or phone number did you use to sign up?</p>
                    <Form onChange={this.handleUsernameChange} style={{ display: "flex", flexDirection: 'column', margin: "20px" }}>
                        <TextField margin="normal" id="username" label="Username/email/phone number" />
                        <p style={{ margin: "0px", fontSize: "12px", color: "#FF857E" }}>{this.state.identifierError}</p>

                    </Form>

                    <p>Back to <span > <button onClick={this.switchToLogIn} style={{ marginTop: "4%", outline: "none", textDecoration: "underline", background: 'none', border: "none", color: "rgb(103, 212, 239)", fontSize: "16px" }}>log in</button>  </span> </p>

                    <Button style={{ width: "100%", height: "40px" }} onClick={this.sendCode} variant="primary" type="submit">
                        Continue
                </Button>

                </>
            )
        }
    }


    render() {
        return (
            <div style={{ textAlign: "center", color: "white", display: "flex", alignContent: "center", flexDirection: "column" }}>
                {this.displayStep()}


            </div>

        )
    }
}
export default ForgotPassword;